export default {
    state: {
        filters: {},
        tab: null,
    },

    mutations: {
        setFilters(state, filters = null) {
            state.filters = filters
        },
        addFilter(state, filter) {
            state.filters = { ...state.filters, ...filter }
        },
        setTab(state, tab) {
            state.tab = tab
        },
    },

    getters: {
        allFilters: state => state.filters,
        currentTab: state => state.tab,
    },

    actions: {
        updateFilters({ commit }, filters) {
            commit('setFilters', filters)
        },
        addOrUpdateFilter({ commit }, filter) {
            commit('addFilter', filter)
        },
        setCurrentTab({ commit }, tab) {
            commit('setTab', tab)
        },
    },
}
